// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BcnI6","placeholdersHeader":"styles_placeholdersHeader__3wpxk","editorStyle":"styles_editorStyle__2yf0P","placeholdersBox":"styles_placeholdersBox__ns5Wv"};